import React, { CSSProperties } from 'react';
import cn from 'classnames';

import styles from './heading.module.scss';


interface IHeadingProps {
  level: 1 | 2 | 3 | 4 | 5 | 6;
  style?: CSSProperties;
  className?: string;
  children: any;
}

export default function Heading({
  level,
  style,
  className,
  children
}: IHeadingProps) {
  const HeadingTag: any = `h${level}`;

  return (
    <HeadingTag
      style={style}
      className={cn(styles.HeadingTag, className)}
    >
      {children}
    </HeadingTag>
  );
}
